export default __webpack_public_path__ + "static/media/A.2d94c505.png";